export class TagRequest<TParams, TResult> {
  public readonly method: string;
  public readonly params: TParams;
  public readonly serviceName: string;

  constructor(serviceName: string, method: string, params: TParams) {
    this.method = method;
    this.params = params;
    this.serviceName = serviceName;
  }

  public data(): TParams {
    return this.params;
  }

  public url(): string {
    return `services/rpc/${this.serviceName}/${this.method}`;
  }
}
